import helper from '@/libs/forms';

const getFields = () => {
  const boolFields = [
    helper.boolRadio(
      'Are there any outstanding judgments against you?', 'judgements', true, 6,
    ),
    helper.boolRadio(
      'Do you have any liens or judgements against you?',
      'liens',
      true,
      6,
    ),
    helper.boolRadio(
      'Any pending/current litigation on any properties within your portfolio?',
      'litigation',
      true,
      6,
    ),
    helper.boolRadio(
      'Have any of your properties been cited for any violation?',
      'violation',
      true,
      6,
    ),
    helper.boolRadio(
      `
        Have you had property foreclosed upon or given title
        or a deed in lieu thereof in the past 7 years?
      `,
      'property',
      true,
      6,
    ),
    helper.boolRadio('Are you a party to a lawsuit?', 'lawsuit', true, 6),
    helper.boolRadio(
      `
        Have you directly or indirectly been obligated on any loan
        which resulted in foreclosure, transfer of title in lieu of
        foreclosure, short sale or judgment?
      `,
      'loan',
      true,
      6,
    ),
    helper.boolRadio(
      'Have you been declared bankrupt within the past 7 years?', 'bankrupt', true, 6,
    ),
    helper.boolRadio('Have you ever been convicted of a felony?', 'felony', true, 6),
    helper.boolRadio(
      "If 'Yes' was it Discharged?",
      'bankruptDischarged',
      model => model.bankrupt === true,
      6,
      '',
      model => model.bankrupt === true,
    ),
  ];
  const FIELD_WITH_NO_EXPLANATION = 'bankruptDischarged';
  const textAreaField = helper.textArea(
    'Explain',
    'explanation',
    null,
    true,
    500,
    12,
    'string',
    model =>
      Object.keys(model).some(
        key => model[key] === true && key !== FIELD_WITH_NO_EXPLANATION,
      ),
  );
  /* eslint no-param-reassign: ["error", { "props": false }] */
  const boolKeys = boolFields.map(field => field.model);
  delete boolKeys[boolKeys.indexOf(FIELD_WITH_NO_EXPLANATION)];
  boolFields.forEach((field) => {
    field.onChanged = (model) => {
      const boolValues = boolKeys.map(key => model[key]);
      const requiresExplanation = boolValues.some(val => val);
      if (!requiresExplanation) {
        model.explanation = null;
      }
    };
  });

  return boolFields.concat([textAreaField]);
};


export default {
  schema: { fields: getFields() },
  formOptions: helper.options('declarations-', false),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/declarations/schema.js